import PropTypes from 'prop-types'

const Render = ({ children, if: condition }) => (condition ? children : null)

Render.propTypes = {
  if: PropTypes.any,
  children: PropTypes.any,
}

Render.defaultProps = {
  if: false,
}

export default Render
